const features = [
  {
    icon: 'ri-file-shield-2-line',
    title: 'No-Logs Policy',
    description: 'We never track, collect, or store your online activity. Your privacy is guaranteed with our strict zero-logs commitment.',
    gradient: 'from-cyan-400 to-cyan-600',
  },
  {
    icon: 'ri-shut-down-line',
    title: 'Kill Switch',
    description: 'Automatic protection that instantly blocks all internet traffic if your VPN connection drops unexpectedly.',
    gradient: 'from-purple-400 to-purple-600',
  },
  {
    icon: 'ri-devices-line',
    title: 'Multi-Device',
    description: 'Protect all your devices simultaneously with one account. Works on desktop, mobile, and tablet platforms.',
    gradient: 'from-pink-400 to-pink-600',
  },
  {
    icon: 'ri-global-line',
    title: 'Global Servers',
    description: 'Access content from anywhere with our worldwide network of high-performance servers across multiple countries.',
    gradient: 'from-orange-400 to-orange-600',
  },
  {
    icon: 'ri-speed-line',
    title: 'High-Speed',
    description: 'Experience blazing-fast connections with unlimited bandwidth. Stream, download, and browse without slowdowns.',
    gradient: 'from-green-400 to-green-600',
  },
  {
    icon: 'ri-lock-2-line',
    title: '24/7 Encryption',
    description: 'Military-grade AES-256 encryption protects your data around the clock, keeping you safe from cyber threats.',
    gradient: 'from-blue-400 to-blue-600',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-xs font-bold tracking-widest text-cyan-500 mb-4">
            FEATURES
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Military-Grade Protection
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base">
            Advanced security features designed to keep you safe, private, and anonymous online
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 hover:-translate-y-2 transition-all duration-300 shadow-lg hover:shadow-2xl cursor-pointer group"
            >
              <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
